import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import type { NavArea } from '../../core/utils/permission.util';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login']);
};

export const permissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  const area = route.data['navArea'] as NavArea | undefined;
  if (!area || auth.canAccessNav(area)) {
    return true;
  }

  return router.createUrlTree(['/dashboard']);
};

export const otpGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.hasPendingOtp()) {
    return true;
  }

  if (auth.isAuthenticated()) {
    return router.createUrlTree(['/dashboard']);
  }

  return router.createUrlTree(['/login']);
};

export const resetPasswordGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const email = route.queryParamMap.get('email') ?? '';

  if (auth.canResetPassword(email)) {
    return true;
  }

  return router.createUrlTree(['/forgot-password']);
};
